import { ServiceStepData } from "@/components/services/ServiceStepCard";

export const serviceSteps: ServiceStepData[] = [
  {
    title: "Supplying",
    description:
      "Once you secure your Georgia Lottery COAM Class B license, we ensure your location is outfitted with the latest, newest, and greatest high-earning skill games available for the Georgia market. One of our technicians will be happy to help you select the perfect model.",
    image1: "/services/01.jpg",
    image2: "/services/02.jpg",
  },
  {
    title: "License Approval",
    description:
      "Getting your GA Lottery COAM Location Class B License is a hassle. Don’t want to deal with the stress of finding rules and regulations by yourself? No need to—our website has all the information conveniently linked for your ease of browsing, to ensure you’re equipped with the proper documentation and fill out your application accurately for speedy approval.",
    image1: "/services/03.jpg",
    image2: "/red-black.webp",
  },
  {
    title: "Set-Up",
    description:
      "Our team of technicians will bring you the latest and best titles for an expert set-up. This includes a quality-assurance check and expert advice if you have questions or concerns. Our primary goal is ensuring your machine is operating perfectly and guests have a place to enjoy game play. We offer 24/7 service so you can schedule a time that works best for your business.",
    image1: "/services/05.jpg",
    image2: "/pink-wave.webp",
  },
];

// Desktop snake path definition
export const desktopSnakePath =
  "M 50 5 L 50 12 L 8 12 L 8 42 L 85 42 L 85 71 L 5 71 L 5 80";

// Mobile snake paths for each step
export const mobileSnakePaths = [
  "M 50 5 L 50 30 L 15 30 L 15 100", // First: Down, left turn, down
  "M 15 5 L 15 30 L 85 30 L 85 100", // Second: Down, right turn, down
  "M 85 5 L 85 30 L 15 30 L 15 100", // Third: Down, left turn, down
];

// Default scroll thresholds for desktop content appearance
export const desktopScrollThresholds = [0.2, 0.5, 0.75];
